export class PersonNameDTO {
  firstName: string;
  middleName: string;
  lastName: string;
}
